import { QueryClient } from "@tanstack/react-query";

/** Shared TanStack Query client (05-frontend-design.md §8.1). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
